import {NgModule} from "@angular/core"

import {MatAutocompleteModule} from "@angular/material/autocomplete"
import {MatButtonModule} from "@angular/material/button"
import {MatButtonToggleModule} from "@angular/material/button-toggle"
import {MatCardModule} from "@angular/material/card"
import {MatChipsModule} from "@angular/material/chips"
import {MatCheckboxModule} from "@angular/material/checkbox"
import {MatTableModule} from "@angular/material/table"
import {MatDialogModule} from "@angular/material/dialog"
import {MatExpansionModule} from "@angular/material/expansion"
import {MatFormFieldModule} from "@angular/material/form-field"

import {MatGridListModule} from "@angular/material/grid-list"
import {MatIconModule} from "@angular/material/icon"
import {MatInputModule} from "@angular/material/input"
import {MatListModule} from "@angular/material/list"
import {MatMenuModule} from "@angular/material/menu"
import {MatPaginatorModule} from "@angular/material/paginator"
import {MatProgressBarModule} from "@angular/material/progress-bar"
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner"
import {MatRadioModule} from "@angular/material/radio"
import {MatSelectModule} from "@angular/material/select"
import {MatSidenavModule} from "@angular/material/sidenav"
import {MatSliderModule} from "@angular/material/slider"
import {MatSlideToggleModule} from "@angular/material/slide-toggle"
import {MatSnackBarModule} from "@angular/material/snack-bar"
import {MatSortModule} from "@angular/material/sort"
import {MatTabsModule} from "@angular/material/tabs"
import {MatToolbarModule} from "@angular/material/toolbar"
import {MatTooltipModule} from "@angular/material/tooltip"
import {MatTreeModule} from "@angular/material/tree"
import {LayoutModule} from "@angular/cdk/layout"
import {MatStepperModule} from "@angular/material/stepper"
import {FormFieldDefaults} from "app/common/material/FormFieldDefaults"
import {DatePickerModule} from "app/common/material/date-picker/DatePickerModule"
import {MatBadgeModule} from "@angular/material"

const MATERIAL_MODULES = [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatTableModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatSnackBarModule,
    MatSortModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    LayoutModule,
    MatButtonModule,
    MatCardModule,
    MatGridListModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatBadgeModule,
    DatePickerModule
]

@NgModule({
    imports: MATERIAL_MODULES,
    exports: MATERIAL_MODULES,
    providers: [FormFieldDefaults]
})
export class MaterialModule {
}
